import i18n from '@i18next/i18n';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import CommonTips, { CommonTipsActionType, CommonTipsType } from '@src/framework/frame/components/common-tips';
import { IPsKeyManagerInjectable } from '../core/interface';
import { isLogin } from '@src/js/common/utils';

export class PsKeyManagerInjectable implements IPsKeyManagerInjectable {
    public handlePskeyError(): void {
        // 注释迁移
        // 本地数据为已登录的情况下收到登录状态错误,提示登录失效
        if (isLogin() && !ENV.IS_LOCAL_EDIT) {
            window.log.info('handlePskeyError logged in');
            const commonTipsConfigRef = {
                message: i18n.t('登录已失效，请刷新'),
                commonTipsType: CommonTipsType.INFO,
                actionType: CommonTipsActionType.LOGIN,
                callBack: () => {},
            };
            if (!window.pray().isPlaying) {
                CommonTips.getInstance().show(commonTipsConfigRef);
            } else {
                CommonTips.getInstance().storage(commonTipsConfigRef);
            }
        }
    }
}
